// src/pages/Holidays.jsx
// Rediseño visual aplicado 2026-05-13. Lógica preservada 1:1.
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../services/api';


const Icon = ({ children, size = 16, stroke = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={stroke}
         strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {children}
    </svg>
);
const I = {
    plus:    <Icon size={14}><path d="M12 5v14" /><path d="M5 12h14" /></Icon>,
    cal:     <Icon size={14}><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></Icon>,
    trash:   <Icon size={12}><path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /></Icon>,
};


function fmtDate(iso) {
    if (!iso) return '';
    try {
        const d = new Date(iso + 'T12:00:00');
        if (isNaN(d.getTime())) return iso;
        return d.toLocaleDateString('es-MX', { weekday: 'short', day: '2-digit', month: 'long', year: 'numeric' });
    } catch { return iso; }
}


const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
.hd-root {
    --hd-accent: var(--brand-700, #0a4aa8);
    --hd-accent-hover: var(--brand-800, #07357f);
    --hd-accent-light: #dbeafe;
    --hd-accent-ring: rgba(10, 74, 168, .12);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    max-width: 760px; margin: 0 auto; padding: 24px 20px 60px;
    color: var(--c-text-1);
}
.hd-root * { box-sizing: border-box; }
.hd-title { font-size: 24px; font-weight: 700; margin: 0 0 4px; letter-spacing: -0.01em; }
.hd-subtitle { color: var(--c-text-3); font-size: 13.5px; margin: 0 0 22px; line-height: 1.5; }

.hd-create {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 14px; padding: 18px 22px; margin-bottom: 22px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
}
.hd-create-title {
    font-size: 11px; font-weight: 700; letter-spacing: 0.5px;
    text-transform: uppercase; color: var(--c-text-4);
    margin: 0 0 14px; display: flex; align-items: center; gap: 6px;
}

.hd-row { display: flex; gap: 8px; margin-bottom: 10px; flex-wrap: wrap; }
.hd-input {
    padding: 9px 12px; font-size: 14px;
    border: 1px solid var(--c-border); border-radius: 8px;
    background: var(--c-input-bg); color: var(--c-text-1);
    font-family: inherit; outline: none;
    transition: border-color .15s, box-shadow .15s;
}
.hd-input:focus { border-color: var(--hd-accent); box-shadow: 0 0 0 3px var(--hd-accent-ring); }
.hd-input-date { flex: 0 0 170px; }
.hd-input-name { flex: 1 1 220px; }
.hd-input-desc { width: 100%; }

.hd-btn {
    display: inline-flex; align-items: center; gap: 6px;
    border: 1px solid transparent; border-radius: 8px;
    padding: 9px 16px; font-size: 13.5px; font-weight: 600;
    cursor: pointer; font-family: inherit;
    transition: all .15s;
}
.hd-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.hd-btn.sm { padding: 5px 11px; font-size: 12px; }
.hd-btn-primary { background: var(--hd-accent); color: #fff; border-color: var(--hd-accent); box-shadow: 0 1px 3px rgba(10,74,168,.25); }
.hd-btn-primary:hover:not(:disabled) { background: var(--hd-accent-hover); border-color: var(--hd-accent-hover); }
.hd-btn-success { background: #059669; color: #fff; border-color: #059669; }
.hd-btn-success:hover:not(:disabled) { background: #047857; border-color: #047857; }
.hd-btn-danger { background: transparent; color: #dc2626; border-color: #fecaca; }
.hd-btn-danger:hover:not(:disabled) { background: var(--c-priority-urgent-bg); border-color: #dc2626; }

.hd-list { display: flex; flex-direction: column; gap: 10px; }
.hd-item {
    background: var(--c-card); border: 1px solid var(--c-border);
    border-radius: 12px; padding: 14px 18px;
    box-shadow: 0 1px 2px rgba(15,23,42,.04);
    display: flex; align-items: center; gap: 14px;
    transition: transform .15s, box-shadow .15s;
}
.hd-item:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(15,23,42,.06); }

.hd-date-badge {
    background: var(--hd-accent-light); color: var(--hd-accent);
    border-radius: 10px; padding: 8px 12px;
    display: flex; flex-direction: column; align-items: center;
    min-width: 64px; flex-shrink: 0;
}
.hd-date-day { font-size: 22px; font-weight: 800; line-height: 1; font-variant-numeric: tabular-nums; letter-spacing: -0.02em; }
.hd-date-month { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-top: 3px; }

.hd-info { flex: 1; min-width: 0; }
.hd-name { font-weight: 700; font-size: 14.5px; color: var(--c-text-1); margin: 0; }
.hd-date-text { font-size: 11.5px; color: var(--c-text-4); margin: 2px 0 0; }
.hd-desc { font-size: 12.5px; color: var(--c-text-3); margin: 4px 0 0; }

.hd-empty {
    text-align: center; padding: 48px 20px;
    color: var(--c-text-4); font-size: 13.5px;
    background: var(--c-card); border: 1px dashed var(--c-border);
    border-radius: 12px;
}
`;


function dayMonth(iso) {
    if (!iso) return { day: '?', month: '' };
    const d = new Date(iso + 'T12:00:00');
    if (isNaN(d.getTime())) return { day: '?', month: '' };
    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    return { day: String(d.getDate()).padStart(2, '0'), month: months[d.getMonth()] };
}


export default function Holidays() {
    const [list,    setList]    = useState([]);
    const [loading, setLoading] = useState(true);
    const [date,    setDate]    = useState('');
    const [name,    setName]    = useState('');
    const [desc,    setDesc]    = useState('');
    const [saving,  setSaving]  = useState(false);

    const load = () => {
        setLoading(true);
        api.get('/holidays')
            .then(res => setList(res.data || []))
            .catch(() => toast.error('No se pudieron cargar los feriados'))
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!date || !name.trim()) { toast.warn('Fecha y nombre son obligatorios'); return; }
        setSaving(true);
        try {
            const res = await api.post('/holidays', { date, name: name.trim(), description: desc });
            setList(prev => [...prev, res.data].sort((a, b) => a.date.localeCompare(b.date)));
            setDate(''); setName(''); setDesc('');
            toast.success('Feriado agregado');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Error al crear');
        } finally { setSaving(false); }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Eliminar este feriado?')) return;
        try {
            await api.delete(`/holidays/${id}`);
            setList(prev => prev.filter(h => h._id !== id));
            toast.info('Feriado eliminado');
        } catch { toast.error('Error al eliminar'); }
    };

    return (
        <>
            <style>{CSS}</style>
            <div className="hd-root">
                <h1 className="hd-title">Feriados</h1>
                <p className="hd-subtitle">
                    Los feriados globales se aplican a todos los agentes en la auto-asignación de tickets
                    (nadie recibe tickets en esas fechas).
                </p>

                <div className="hd-create">
                    <p className="hd-create-title">{I.cal} Nuevo feriado</p>
                    <form onSubmit={handleCreate}>
                        <div className="hd-row">
                            <input
                                type="date" className="hd-input hd-input-date"
                                value={date} onChange={e => setDate(e.target.value)}
                            />
                            <input
                                type="text" className="hd-input hd-input-name"
                                placeholder="Nombre (ej. Día del Trabajo)"
                                value={name} onChange={e => setName(e.target.value)}
                            />
                            <button type="submit" className="hd-btn hd-btn-success" disabled={saving}>
                                {saving ? <Spinner size="sm" animation="border" /> : <>{I.plus} Agregar</>}
                            </button>
                        </div>
                        <input
                            type="text" className="hd-input hd-input-desc"
                            placeholder="Descripción (opcional)"
                            value={desc} onChange={e => setDesc(e.target.value)}
                        />
                    </form>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: 60 }}><Spinner animation="border" variant="primary" /></div>
                ) : list.length === 0 ? (
                    <p className="hd-empty">No hay feriados cargados todavía.</p>
                ) : (
                    <div className="hd-list">
                        {list.map(h => {
                            const dm = dayMonth(h.date);
                            return (
                                <div key={h._id} className="hd-item">
                                    <div className="hd-date-badge">
                                        <span className="hd-date-day">{dm.day}</span>
                                        <span className="hd-date-month">{dm.month}</span>
                                    </div>
                                    <div className="hd-info">
                                        <p className="hd-name">{h.name}</p>
                                        <p className="hd-date-text">{fmtDate(h.date)}</p>
                                        {h.description && <p className="hd-desc">{h.description}</p>}
                                    </div>
                                    <button type="button" className="hd-btn hd-btn-danger sm" onClick={() => handleDelete(h._id)}>
                                        {I.trash} Eliminar
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </>
    );
}
